import React from 'react';
import { Link } from 'react-router-dom';
import './transparencia.css';

import Navbar from '../Components/Navbar/navbar.jsx';
import Complace from '../Components/Complace/complace.jsx';

function Transparencia(){
    return <div>
      <Navbar/>
      <section id="comp">
        <div className="container">
        <p className='fs-1 fw-bold text-center'>TRANSPARÊNCIA - OUVIDORIA</p> 

          <p id="justificar">
           <p className='fw-normal'> Você está no Canal de Integridade da Editora Alphaville, destinado aos nossos colaboradores, clientes, fornecedores e público em geral. Por aqui é possível entrar em contato com o nosso Departamento de Compliance para comunicar, de forma segura, situações que não estejam de acordo com normas e políticas internas da empresa, bem como infrações às leis e regulamentações vigentes.</p>
          </p>
           <Link to="/app/transparenciacomp"><a>Ler mais...</a></Link>

        </div>
       </section>

       <div className="row" id="planos">

       </div>
       <Complace/>
    </div>
  }

export default Transparencia;